<template>
  <div id="ReviewsAll">
    <v-container>
      <v-row>
        <h1 class="mt-12 mb-12 font-weight-light">
          Ratings & Reviews
        </h1>
      </v-row>

      <!-- CREATE NEW REVIEW -->
      <v-card class="mx-auto mb-12" max-width="700" outlined>
        <v-list-item three-line>
          <v-col>
            <v-row class="review-first-row">
              <!-- <v-list-item-avatar size="48" color="black">
                <img :src="3" alt="Reviewer's Profile Picture" />
              </v-list-item-avatar> -->
              <v-file-input
                v-model="photo"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Pick an image"
                prepend-icon="mdi-camera"
                label="Profile Photo"
              ></v-file-input>
              <!-- <p
                style="font-size: 1.25rem;
  font-weight: bold;"
                class=""
              >
                awefawef
              </p> -->
              <!-- :rules="textFieldRules" -->
              <v-text-field
                v-model="name"
                :counter="10"
                label="Name"
                required
              ></v-text-field>
              <v-col class="text-right">
                <v-rating
                  v-model="rating"
                  color="yellow darken-3"
                  background-color="grey darken-1"
                  half-increments
                  medium
                  hover
                  aria-label="Rate out of 5 stars"
                >
                  <!-- <template v-slot:item="props">
                    <v-icon aria-label="star" color="amber" size="20">{{
                      props.isFilled ? 'mdi-star' : 'mdi-star-outline'
                    }}</v-icon>
                  </template> -->
                </v-rating>
                <p>{{ todaysDate }}</p>
              </v-col>
            </v-row>
            <v-row style="width: 100%">
              <v-list-item-content>
                <v-textarea
                  outlined
                  v-model="review"
                  name="review-textarea"
                  label="Type your review of this listing here."
                ></v-textarea>
              </v-list-item-content>
            </v-row>
          </v-col>
        </v-list-item>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn
                class="pl-12 pr-12"
                @click="postCreateReview()"
                x-large
                color="primary"
                aria-label="Submit Review button"
              >
                <v-icon class="pr-3">mdi-checkbox-marked-circle-outline</v-icon>
                Submit your Review
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>

      <!-- AVERAGE RATINGS -->
      <v-row>
        <v-col cols="12" md="6">
          Average
          <b>4.9</b>
          out of 5
        </v-col>
        <v-col cols="12" md="6"> Total Number of Ratings: <b>25</b> </v-col>
      </v-row>

      <v-row v-for="rating in ratings" :key="rating.id" class="rating-row">
        <v-rating
          class="rating"
          readonly
          :value="rating.stars"
          color="yellow darken-3"
          background-color="grey darken-1"
          empty-icon="$ratingFull"
          half-increments
          small
          hover
          aria-label="Rate out of 5 stars"
        >
          <template v-slot:item="props">
            <v-icon aria-label="star" color="amber" size="20">{{
              props.isFilled ? 'mdi-star' : ''
            }}</v-icon>
          </template>
        </v-rating>
        <v-progress-linear
          class="progress"
          :value="rating.progress"
        ></v-progress-linear>
      </v-row>

      <!-- ALL REVIEWS -->
      <v-row class="mt-12">
        <Reviews
          class="mb-6"
          v-for="n in allReviews"
          :key="n.id"
          :reviewData="n"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Reviews from '../components/Reviews';
import axios from 'axios';

export default {
  name: 'ReviewsAll',
  components: {
    Reviews,
  },
  data() {
    return {
      allReviews: null,
      ratings: [
        { stars: 5, progress: 70 },
        { stars: 4, progress: 15 },
        { stars: 3, progress: 5 },
        { stars: 2, progress: 2 },
        { stars: 1, progress: 1 },
      ],
      rating: 5,
      name: '',
      photo: new Image(),
      review: '',
      textFieldRules: [
        // (value) => !!value || 'Required.',
        // (value) => (value && value.length >= 3) || 'Min 3 characters',
        // (value) =>
        //   !value ||
        //   value.size < 2000000 ||
        //   'Avatar size should be less than 2 MB!',
      ],
    };
  },
  computed: {
    todaysDate() {
      return String(new Date())
        .split(' ')
        .slice(1, 4)
        .join(' ');
    },
  },
  created() {
    // console.log(this.$route.params.allReviews);
    this.allReviews = this.$route.params.allReviews;
  },
  methods: {
    postCreateReview() {
      const data = {
        fields: {
          NAME: `${this.name}`,
          PHOTO: `${this.photo}`,
          REVIEW: `${this.review}`,
          RATING: `${this.rating}`,
          TIMESTAMP: new Date(),
        },
      };

      const options = {
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
          'Content-Type': 'application/json',
        },
      };

      console.log(data);
      console.log(options);

      axios
        .post(
          'https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/user-reviews',
          data,
          options
        )
        .then(
          (r) => {
            console.log(r);
            this.$store.dispatch('setSnackbar', {
              color: 'success',
              text: 'Your review was submitted.',
            });
          },
          (error) => {
            console.log(error);
            this.$store.dispatch('setSnackbar', {
              color: 'error',
              text: 'Your review was unable to be submitted.',
            });
          }
        );
    },
  },
};
</script>

<style scoped>
.rating-row {
  display: grid;
  grid-template-columns: 0.25fr 1fr;
  align-items: center;
}

/* .rating {
  display: inline-block;
}

.progress {
  display: inline-block;
} */
</style>
